exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".reviewFormStyle{width:700px;height:100px;margin:auto}.cancelButton,.submitButton{margin:10px 0px 0px 10px}.form-group{padding:10px !important}h1{margin:auto;align-content:center}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/shared/ReviewForm.scss
// module id = 255
// module chunks = 0